import React from 'react';

import Contact from './Contact';

function ContactPage() {
    return ( 
        <>
        <Contact />        
        </>
     );
}

export default ContactPage;